import { render, staticRenderFns } from "./ShunyiHome.vue?vue&type=template&id=7432706c&scoped=true"
import script from "./ShunyiHome.vue?vue&type=script&lang=js"
export * from "./ShunyiHome.vue?vue&type=script&lang=js"
import style0 from "./ShunyiHome.vue?vue&type=style&index=0&id=7432706c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432706c",
  null
  
)

export default component.exports